"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram, Linkedin, Github, Phone, Mail } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterNavConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4, 5].map(i => <div key={i} data-index={i} className="h-5 w-24 bg-muted-dark/20 animate-pulse rounded" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-3">
      {menuItems.slice(0, 5).map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-sm text-foreground-dark/80 hover:text-foreground-dark relative inline-block transition-colors duration-200 after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-0 after:bg-foreground-dark after:transition-all after:duration-300 hover:after:w-full">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const socials = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Github,
    href: "https://github.com",
    label: "GitHub"
  }];
  return <footer ref={ref} className={`bg-dark-background text-foreground-dark py-16 px-6 transition-all duration-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 items-start">
        <div className="flex justify-center md:justify-start">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1510319/img/cashhome_logo.png" alt="CashHome Logo" className="h-7" />
        </div>

        <div className="flex justify-center md:justify-start">
          <MenuProvider menu_id="12">
            <FooterNavConsumer />
          </MenuProvider>
        </div>

        <div className="flex flex-col gap-4">
          <h3 className="text-base font-semibold text-foreground-dark">Contact Us</h3>
          <div className="flex flex-col gap-3">
            <Link to="tel:+12063387815" className="group flex items-center gap-2 text-sm text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-200" aria-label="Call us at +1 206-338-7815">
              <Phone className="size-4 text-primary transition-transform duration-200 group-hover:scale-110" />
              <span>+1 206-338-7815</span>
            </Link>
            <Link to="mailto:thai.eang00@gmail.com" className="group flex items-center gap-2 text-sm text-foreground-dark/80 hover:text-foreground-dark transition-colors duration-200" aria-label="Email us at thai.eang00@gmail.com">
              <Mail className="size-4 text-primary transition-transform duration-200 group-hover:scale-110" />
              <span>thai.eang00@gmail.com</span>
            </Link>
          </div>
        </div>

        <div className="flex justify-center md:justify-end gap-4">
          {socials.map((social, i) => {
          const Icon = social.icon;
          return <Link key={social.label} data-index={i} to={social.href} newTab aria-label={social.label} className="text-foreground-dark/70 hover:text-foreground-dark transition-all duration-200 hover:scale-105">
                <Icon className="size-5" />
              </Link>;
        })}
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-8 pt-6 border-t border-foreground-dark/10">
        <div className="flex items-center justify-center gap-2 text-xs text-foreground-dark/60">
          <Link to="https://cashhome4u.com/privacy-policy" className="hover:underline hover:text-foreground-dark transition-colors duration-200">
            Privacy Policy
          </Link>
          <span>|</span>
          <Link to="https://cashhome4u.com/terms-of-service" className="hover:underline hover:text-foreground-dark transition-colors duration-200">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>;
}